<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'}
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    표-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :is-not-dot-in-label="true"
      title="통학보조"
      tableHeaderTitle="점검항목"
      :list="form.inspectList_1"
      @update-list-check="updateListCheck_1"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"/>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspect from '@/components/TableInspect'

export default {
  components: {
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        photoList: [],
        inspectList_1: [
          {
            id: 1,
            label: "1. 운전원은 차량이 항상 청결하도록 유지하였는가?",
            is_checked: "",
          },
          {
            id: 2,
            label: "2. 운전 중 흡연 및 식음, 통화 등은 하지 않았는가?",
            is_checked: "",
          },
          {
            id: 3,
            label: "3. 운전 중 직무수행에 필요한 사람 이외의 탑승은 없었는가?",
            is_checked: "",
          },
          {
            id: 4,
            label: "4. 배차되지 않은 차량의 사적인 운행 행위는 금지되었는가?",
            is_checked: "",
          },
          {
            id: 5,
            label: "5. 운전원은 차량 밖으로 이동시 잠금장치를 하였는가?",
            is_checked: "",
          },
          {
            id: 6,
            label: "6. 운전원은 경제속도운행 및 안전운행에 노력하였는가?",
            is_checked: "",
          },
          {
            id: 7,
            label: "7. 승차 시 학생들의 안전한 탑승이 확인 된 후에 출발하였는가?",
            is_checked: "",
          },
          {
            id: 8,
            label: "8. 하차 시 학생들의 안전한 상태를 확인 후 하차하였는가?",
            is_checked: "",
          },
          {
            id: 9,
            label: "9. 승하차 시 지정된 장소에 대기하고 있던 학부모와 인사를 나누고 학생들을 안전하게 인도하였는가?",
            is_checked: "",
          },
          {
            id: 10,
            label: "10. 운행 중 창밖으로 손을 내밀거나 하는 위험 행동을 통제했는가?",
            is_checked: "",
          },
          {
            id: 11,
            label: "11. 출발 전 학생들의 안전밸트 착용 등의 상태를 확인하였는가?",
            is_checked: "",
          },
          {
            id: 12,
            label: "12. 차량의 학교 도착 후 유실물과 차량의 상태는 확인하였는가?",
            is_checked: "",
          },

        ],
      },
    };
  },
  methods: {
    updateListCheck_1 (indexRows, text) {
      this.form.inspectList_1[indexRows].is_checked = text
    },
  },
};
</script>

<style scoped lang="scss">
</style>
